import styled from "styled-components";
import {useEffect, useState} from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  gap: 10px;

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

const PaginationButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const PageButton = styled.button`
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #007bff;
  background-color: ${({ active }) => (active ? "#007bff" : "white")};
  color: ${({ active }) => (active ? "white" : "#007bff")};
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
    color: white;
  }

  &:disabled {
    background-color: #ddd;
    color: #888;
    cursor: not-allowed;
  }
`;

const ItemsPerPageContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label`
  margin-right: 8px;
  color: #333;
`;

const Select = styled.select`
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const Pagination = ({ items }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(
    searchParams.get("page") ? parseInt(searchParams.get("page"), 10) : 1
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const [itemsPerPage, setItemsPerPage] = useState(
    searchParams.get("itemPerPage") ? parseInt(searchParams.get("itemPerPage"), 10) : 10
  );

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    params.set("page", currentPage);
    params.set("itemPerPage", itemsPerPage);
    setSearchParams(params);
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const totalPages = Math.ceil(items / itemsPerPage);

  const goToPage = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleItemsPerPageChange = (event) => {
    // setItemsPerPage(parseInt(event.target.value, 10));
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const renderPagination = () => {
    const pagination = [];
    const maxPagesToShow = isMobile ? 3 : 5;
    let startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - (maxPagesToShow - 1), 1);
    }

    if (startPage > 1) {
      pagination.push(
        <PageButton
          key="prev"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &lt;
        </PageButton>
      );
      if (startPage > 2) {
        pagination.push(<span key="dot-start">...</span>);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pagination.push(
        <PageButton key={i} onClick={() => goToPage(i)} active={currentPage === i}>
          {i}
        </PageButton>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pagination.push(<span key="dot-end">...</span>);
      }
      pagination.push(
        <PageButton
          key="next"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          &gt;
        </PageButton>
      );
    }

    return pagination;
  };

  console.log(renderPagination());
  return (
    <PaginationContainer>
      <PaginationButtons>{renderPagination()}</PaginationButtons>
      <ItemsPerPageContainer>
        <Label htmlFor="itemsPerPage">Items per page:</Label>
        <Select id="itemsPerPage" value={itemsPerPage} onChange={handleItemsPerPageChange}>
          {[1, 5, 10, 25, 50, 100].map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </ItemsPerPageContainer>
    </PaginationContainer>
  );
};

export default Pagination;
